var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ac-statistics-card"},[_c('div',{staticClass:"value-slot"},[_vm._t("statisticsValue")],2),_c('div',{staticClass:"title-slot"},[_vm._t("statisticsTitle")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }